export default __webpack_public_path__ + "static/media/power-off-solid.241cad54.svg";